import type { KeyboardEvent, RefObject } from "react";
import { Icon } from "../../icons";

interface SelectSearchProps {
  inputRef: RefObject<HTMLInputElement | null>;
  listId: string;
  /** Id of the highlighted option, if any. */
  activeDescendant?: string;
  placeholder: string;
  query: string;
  onQueryChange: (query: string) => void;
  onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

/** Filter box at the top of long lists; it takes the focus and drives the listbox. */
export function SelectSearch({ inputRef, listId, activeDescendant, placeholder, query, onQueryChange, onKeyDown }: SelectSearchProps): React.JSX.Element {
  return (
    <div className="nb-select-search">
      <Icon name="search" aria-hidden="true" />
      <input
        ref={inputRef}
        type="text"
        role="combobox"
        aria-label={placeholder}
        aria-expanded
        aria-controls={listId}
        aria-autocomplete="list"
        aria-activedescendant={activeDescendant}
        placeholder={placeholder}
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        onKeyDown={onKeyDown}
      />
    </div>
  );
}
